import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, generatePath } from 'react-router-dom';
import { Page } from 'src/components-dummy';
import { useAppSelector } from 'src/hooks';
import { RoutedComponentProps } from 'src/app-routes';
import { ExperimentWizard } from 'src/components-bl/Experiment/ExperimentWizard';
import { editExperimentContainerActionMethods } from '../EditExperimentContainer/Actions';
import './ExperimentWizardContainer.scss';

type ExperimentWizardContainerProps = RoutedComponentProps;

export const ExperimentWizardContainer = ({
  permittedRouteMap,
}: ExperimentWizardContainerProps): JSX.Element | null => {
  const dispatch = useDispatch();
  const { experimentId } = useParams<{ experimentId: string }>();
  const shopId = useAppSelector(state => state.shop.current?.shopId);
  const selectedExperiment = useAppSelector(state => state.experiments.selectedExperiment);
  const runningExperiment = useAppSelector(state => state.experiments.runningExperiment);

  const experimentListPath =
    (permittedRouteMap.experiments?.path &&
      shopId &&
      generatePath(permittedRouteMap.experiments?.path, { shopId })) ||
    undefined;

  const onClose = (): void => {
    if (experimentListPath) {
      dispatch(editExperimentContainerActionMethods.navigateTo({ navigateTo: experimentListPath }));
    }
  };

  const onLaunched = (launchedExperimentId: string): void => {
    const dashboardRoute = permittedRouteMap.abTestDashboard?.path;
    if (dashboardRoute && shopId) {
      dispatch(
        editExperimentContainerActionMethods.navigateTo({
          navigateTo: generatePath(dashboardRoute, { shopId, experimentId: launchedExperimentId }),
        })
      );
    }
  };

  useEffect(() => {
    if (shopId && experimentId !== selectedExperiment?.id) {
      dispatch(
        editExperimentContainerActionMethods.getExperiment({
          shopId,
          id: experimentId,
          pathToNavigateOnFail: experimentListPath,
        })
      );
    }
  }, [shopId, experimentId, selectedExperiment?.id]);

  useEffect(() => {
    return () => {
      dispatch(editExperimentContainerActionMethods.clearCurrentExperiment());
    };
  }, []);

  if (!shopId) return null;

  return (
    <div className='syte-experiment-wizard-container'>
      <Page>
        <Page.Header>{null}</Page.Header>
        <Page.Content>
          <ExperimentWizard
            shopId={shopId}
            experiment={selectedExperiment}
            dispatch={dispatch}
            permittedRouteMap={permittedRouteMap}
            onClose={onClose}
            hasRunningExperiment={!!runningExperiment}
            runningExperimentId={runningExperiment?.id}
            onLaunched={onLaunched}
          />
        </Page.Content>
      </Page>
    </div>
  );
};
